<template>
    <div class="app-feature operate-btn" @click="openDialog" title="新功能展板">
        <i class="nucfont inuc-tips"></i>

        <el-dialog title="新功能展板"
                   :visible.sync="dialog"
                   custom-class="dialog-app-feature"
                   width="1100px"
                   :close-on-click-modal="false"
                   :append-to-body="true"
                   :modal-append-to-body="true">
            <template #title>
                <span class="el-dialog__title"><i class="nucfont inuc-tips"></i>新功能展板</span>
            </template>
            <div class="feature-wrap">
                <ul class="feature-list">
                    <li class="feature-item"
                        v-for="(item, index) in featList"
                        :key="index"
                        :class="{'active': active === index}"
                        @click="viewContent(index)"
                    >
                        <p class="title">
                            {{item.title}}
                        </p>
                        <div class="other">
                            <el-tag size="small">{{item.tag}}</el-tag>
                            <span class="date">{{item.date}}</span>
                        </div>
                    </li>
                </ul>

                <div class="feature-content" v-loading="loading">
                    <iframe ref="iframe" class="content-frame" :src="currentUrl" frameborder="0"></iframe>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {Storage, Ticket} from '@/utils'

export default {
    components: {},

    data() {
        return {
            dialog: false,
            active: 0,
            loading: false,
            featList: [
                {
                    title: '培训专题功能',
                    url: 'https://s3.cn-north-1.amazonaws.com.cn/s3.anjianba.cn/res/trainSpecial.html',
                    //url: '/trainSpecial.html',
                    date: '2022-3-22',
                    tag: 'v2.5.7.2'
                },
                {
                    title: '职鉴图库功能',
                    url: 'https://s3.cn-north-1.amazonaws.com.cn/s3.anjianba.cn/res/fiscan.html',
                    date: '2022-1-6',
                    tag: 'v2.5.7'
                },
                {
                    title: '监考中心功能',
                    url: 'https://s3.cn-north-1.amazonaws.com.cn/s3.anjianba.cn/res/antiCheat.html',
                    date: '2022-1-6',
                    tag: 'v2.5.7'
                }
            ]
        }
    },

    computed: {
        currentUrl() {
            return this.featList[this.active]["url"]
        }
    },

    mounted() {
        const creatorID = Ticket.get().userID
        const featureKey = `feature_${creatorID}`;
        if (!Storage.get(featureKey)) {
            this.dialog = true
            Storage.set(featureKey, true)
        }
    },

    watch: {
        dialog(v) {
            if (!v) {
                this.loading = true
            }

            if (v) {
                this.$nextTick(() => {
                    this.$refs.iframe.onload = () => {
                        this.loading = false
                    }
                })
            }
        }
    },

    methods: {
        openDialog() {
            this.dialog = true
        },
        viewContent(index) {
            if (this.active === index) return

            this.active = index
            this.loading = true

            // backup
            this.backupTimer && clearInterval(this.backupTimer)
            this.backupTimer = setTimeout(() => {
                if (this.loading) {
                    this.loading = false
                }
            }, 3000)
        }
    },
}
</script>

<style lang="scss">
.dialog-app-feature {
    border-radius: 10px!important;
    overflow: hidden;

    .el-dialog__header {
        background-color: #F2F4FD;
        .inuc-tips {
            margin-right: 4px;
        }
    }

    .el-dialog__body {
        padding: 0;
    }

    .feature-wrap {
        display: flex;
        height: 590px;
    }

    .feature-list {
        width: 260px;
        //border-right: 1px solid #f1f3f8;
        border-right: 1px solid #dfe4ed;
        background-color: #f9f9f9;

        .feature-item {
            padding: 12px 20px;
            line-height: 1.7;
            cursor: pointer;
            &:hover {
                .title {
                    color: $blue;
                }
            }
            &.active {
                margin-right: -1px;
                border-right: 1px solid transparent;
                border-top: 1px solid #dfe4ed;
                border-bottom: 1px solid #dfe4ed;
                border-left: 5px solid #1e93c9;
                background-color: #fff;
                &:first-child {
                    border-top: none;
                }
                .title {
                    color: $blue;
                }
            }
        }

        .other {
            display: flex;
            justify-content: space-between;
            margin-top: 5px;
            font-size: 12px;
            .date {
                color: #999;
            }
        }
    }

    .feature-content {
        flex: 1;
        //padding-left: 20px;

        .content-frame {
            width: 100%;
            height: 100%;
        }
    }
}

</style>
